import { useState } from "react";
import Button from "../../../../shared/button";
import { useGetAllInvoicesEmailMutation, useGetOutlookCredentialsQuery } from "../../../../store/google-reservations/googleReservationsApi";
import {
  useGetCurrentAuthUrlQuery,
} from "../../../../store/reservations/reservationsApi";

const InvoiceEmailsTable = () => {
  const [errorForInvoiceEmails, setErrorForInvoiceEmails] = useState<string>();
  const { data: authUrl } = useGetCurrentAuthUrlQuery({});
  const { data: outlookCredentials } = useGetOutlookCredentialsQuery();
  const [getAllReservations, { isLoading, data, error }] = useGetAllInvoicesEmailMutation();

  const handleGetAllInvoices = async () => {
    try {
      const { accessToken, refreshToken } = outlookCredentials || {};
      localStorage.setItem("googleAccessToken", accessToken || "");
      localStorage.setItem("googleRefreshToken", refreshToken || "");
      setErrorForInvoiceEmails(undefined)
      if (accessToken) {
        await getAllReservations(accessToken || "").unwrap();
      } else {
        window.location.assign(authUrl.authUrl);
      }
    } catch (err: any) {
      setErrorForInvoiceEmails(err?.data?.message || '')
    }
  };

  const errorObj = error as { data: { message: string } };
  return (
    <div className="bg-white p-4">
      <h2 className="text-[#5D6679] text-base mb-2">Invoice E-mails</h2>
      <div className="bg-[#F9F9F9] rounded-lg px-4 py-6">
        <div className="flex flex-row items-center">
          <img src="/assets/shared/email.svg" alt="Email Icon" />
          <div className="ml-3">
            <p className="text-[#161048] text-xs">Last Processing - </p>
            <h4 className="text-[#202020] text-base font-bold">New Emails</h4>
          </div>
        </div>
        <Button
          icon={
            <img
              alt="reviewt"
              className="mr-2"
              src="/assets/shared/reviewt.svg"
            />
          }
          loading={isLoading}
          onClickButton={handleGetAllInvoices}
          label="Review Emails"
          className="mt-3 bg-primary-default rounded-xl py-2 px-4 text-[#8DF24C] flex flex-row items-center"
        />
      </div>
      {(error || data) && (
        <div className="my-3 bg-[#F9F9F9] rounded-lg p-4">
          {(error || errorForInvoiceEmails) ? (
            <>{errorObj?.data?.message || errorForInvoiceEmails}</>
          ) : (
            <p className="text-base ">
              {data?.message} <br />
              {data?.totalEmailsProcessed && (
                <span>
                  Total Email processed: {data?.totalEmailsProcessed}{" "}
                </span>
              )}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default InvoiceEmailsTable;
